import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const location = useLocation();
  const isCypressAuthorized = localStorage.getItem('isCypress') === 'true';

  useEffect(() => {
    if (isCypressAuthorized) {
      return;
    }
    if (!isLoading && !isAuthenticated) {
      loginWithRedirect({
        authorizationParams: {prompt: 'login'},
        appState: { returnTo: location.pathname },
      });
    }
  }, [isLoading, isAuthenticated, loginWithRedirect, location.pathname, isCypressAuthorized]);

  if (isCypressAuthorized) {
    return children;
  }

  if (isLoading || !isAuthenticated) {
    return <div>Loading...</div>;
  }

  return children;
};

export default ProtectedRoute;
